import { TimeSlotUtil } from '@commons/models/time-slot';

import { Campaign, CampaignDto, CCXMLTimeSlotDto, isNumber, TimeSlot } from '@contact/upgrade';

export interface CampaignLiteDto {
  campaignUuid: string;
  campaignName: string;
  campaignType: string;
  campaignBeginDate?: Date | number;
  campaignEndDate?: Date | number;
}

export class CampaignUtil {
  static fromDto(toConvert: CampaignDto, $filter: any): Campaign {
    let convertedTimeSlots = toConvert.timeSlots.map((timeSlotDto: CCXMLTimeSlotDto): TimeSlot => TimeSlotUtil.fromDto(timeSlotDto));
    return {
      id: toConvert.idCampaign,
      name: toConvert.name,
      beginDate: isNumber(toConvert.beginDate) ? toConvert.beginDate : toConvert.beginDate.getTime(),
      endDate: isNumber(toConvert.endDate) ? toConvert.endDate : toConvert.endDate.getTime(),
      type: toConvert.campaignType,
      description: toConvert.description,
      timeSlots: $filter('orderBy')(convertedTimeSlots, 'beginDate', false),
      scriptArgumentUuid: toConvert.scriptArgumentUuid,
      enableCsrReassign: toConvert.enableCsrReassign,
      stream: {
        name: toConvert.stream.name,
        uuid: toConvert.stream.streamUuid,
      },
    } as Campaign;
  }

  static fromDtoLite(toConvert: CampaignLiteDto): Campaign {
    return {
      id: toConvert.campaignUuid,
      name: toConvert.campaignName,
      type: toConvert.campaignType,
      beginDate: isNumber(toConvert.campaignBeginDate) ? toConvert.campaignBeginDate : toConvert.campaignBeginDate?.getTime(),
      endDate: isNumber(toConvert.campaignEndDate) ? toConvert.campaignEndDate : toConvert.campaignEndDate?.getTime(),
    } as Campaign;
  }
}
